import { render } from "./MyBadges-View.vue?vue&type=template&id=765624ce"
import script from "./MyBadges-View.vue?vue&type=script&lang=js"
export * from "./MyBadges-View.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__